const FEE_TRANSACTION_TYPES = {
  ACCOUNT_FUNDING_AUTHORIZATION_CLEARING: `account.funding.authorization.clearing`,
  ACCOUNT_FUNDING_AUTH_PLUS_CAPTURE: `account.funding.auth_plus_capture`,
  AUTHORIZATION_CLEARING: `authorization.clearing`,
  AUTHORIZATION_CLEARING_ATM_WITHDRAWAL: `authorization.clearing.atm.withdrawal`,
  AUTHORIZATION_CLEARING_QUASI_CASH: `authorization.clearing.quasi.cash`,
  ORIGINAL_CREDIT_AUTH_PLUS_CAPTURE: `original.credit.auth_plus_capture`,
  PINDEBIT: `pindebit`,
  PINDEBIT_ATM_WITHDRAWAL: `pindebit.atm.withdrawal`,
  PINDEBIT_AUTHORIZATION: `pindebit.authorization`,
  PINDEBIT_AUTHORIZATION_CLEARING: `pindebit.authorization.clearing`,
  PINDEBIT_CASHBACK: `pindebit.cashback`,
  PINDEBIT_QUASI_CASH: `pindebit.quasi.cash`,
};

const DISPUTABLE_TRANSACTION_TYPES = [
  FEE_TRANSACTION_TYPES.ACCOUNT_FUNDING_AUTHORIZATION_CLEARING,
  FEE_TRANSACTION_TYPES.ACCOUNT_FUNDING_AUTH_PLUS_CAPTURE,
  FEE_TRANSACTION_TYPES.AUTHORIZATION_CLEARING,
  FEE_TRANSACTION_TYPES.AUTHORIZATION_CLEARING_ATM_WITHDRAWAL,
  FEE_TRANSACTION_TYPES.AUTHORIZATION_CLEARING_QUASI_CASH,
  FEE_TRANSACTION_TYPES.ORIGINAL_CREDIT_AUTH_PLUS_CAPTURE,
  FEE_TRANSACTION_TYPES.PINDEBIT,
  FEE_TRANSACTION_TYPES.PINDEBIT_ATM_WITHDRAWAL,
  FEE_TRANSACTION_TYPES.PINDEBIT_AUTHORIZATION,
  FEE_TRANSACTION_TYPES.PINDEBIT_AUTHORIZATION_CLEARING,
  FEE_TRANSACTION_TYPES.PINDEBIT_CASHBACK,
  FEE_TRANSACTION_TYPES.PINDEBIT_QUASI_CASH,
];

module.exports = {
  DISPUTABLE_TRANSACTION_TYPES,
  FEE_TRANSACTION_TYPES,
};
